type ClerkSession = {
  getToken: (options?: { template: string }) => Promise<string | null>;
};

type ClerkGlobal = {
  session?: ClerkSession | null;
};

const TOKEN_WAIT_ATTEMPTS = 20;
const TOKEN_WAIT_INTERVAL_MS = 100;

function getClerkGlobal(): ClerkGlobal | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return (window as unknown as { Clerk?: ClerkGlobal }).Clerk;
}

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function getToken(): Promise<string> {
  for (let attempt = 0; attempt < TOKEN_WAIT_ATTEMPTS; attempt += 1) {
    const token = await getClerkGlobal()?.session?.getToken();

    if (token) {
      return token;
    }

    await delay(TOKEN_WAIT_INTERVAL_MS);
  }

  return '';
}
